<ngx-spinner
  bdColor="rgba(0, 0, 0, .9)"
  size="default"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true"
></ngx-spinner>
<router-outlet></router-outlet>
